import Service from './service';

export default class StationService extends Service {
  baseApi = '/stations';

  async getStations(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async createStation(body) {
    return await this.postResource(this.baseApi, body, { returnErrors: true });
  }

  async updateStation(id, body) {
    return await this.putResource(`${this.baseApi}/${id}`, body, { returnErrors: true });
  }

  async deleteStation(id) {
    return await this.deleteResource(`${this.baseApi}/${id}`);
  }
}
